import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComparisonCheckboxGridAllOf = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 9,
			width: 9,
			height: 9,
			rx: 1.5,
			ry: 1.5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 22,
			y: 9,
			width: 9,
			height: 9,
			rx: 1.5,
			ry: 1.5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 22,
			width: 9,
			height: 9,
			rx: 1.5,
			ry: 1.5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 22,
			y: 22,
			width: 9,
			height: 9,
			rx: 1.5,
			ry: 1.5,
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgComparisonCheckboxGridAllOf);
export default ForwardRef;
